export interface PerformanceChartConfig {
  chartType: 'line' | 'bar';
  stacked?: boolean;
  titleKey: string;
}

const PERFORMANCE_CHART_CONFIG: Record<string, PerformanceChartConfig> = {
  followers_gained: {
    chartType: 'bar',
    stacked: true,
    titleKey: 'analyticsPerformance.newFollowersOverTime',
  },
  engagements: {
    chartType: 'line',
    titleKey: 'analyticsPerformance.engagementOverTime',
  },
  reach: {
    chartType: 'line',
    titleKey: 'analyticsPerformance.reachOverTime',
  },
  impressions: {
    chartType: 'line',
    titleKey: 'analyticsPerformance.impressionsOverTime',
  },
  views: {
    chartType: 'line',
    titleKey: 'analyticsPerformance.metrics.views',
  },
  followers: {
    chartType: 'line',
    titleKey: 'analyticsPerformance.metrics.totalFollowers',
  },
};

export function getPerformanceChartConfig(
  metricKey: string,
): PerformanceChartConfig | null {
  return PERFORMANCE_CHART_CONFIG[metricKey] ?? null;
}

export function splitPerformanceMetricsByChartSupport(
  performanceMetrics: string[],
): { chartMetrics: string[]; tileMetrics: string[] } {
  const chartMetrics: string[] = [];
  const tileMetrics: string[] = [];

  for (const metric of performanceMetrics) {
    if (getPerformanceChartConfig(metric)) {
      chartMetrics.push(metric);
    } else {
      tileMetrics.push(metric);
    }
  }

  return { chartMetrics, tileMetrics };
}
